import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { generateFieldsFeatures } from "../Community/CommunityFriendlyOrganisation.drilldowndata";

export const generateFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[]
): ModuleFields[] => {
  return languages.flatMap((lang) => {
    const fields: ModuleFields[] = [];
    if (lang.parseField === "field_content_english") {
      fields.push({
        fieldName: `Image`,
        fieldValue: `${basePath}.banner`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "image",
        name: `${lang.parseField}.${basePath}.banner`,
        formType: "file",
        usedFileType: "image/*",
        label: `Image`,
        placeholder: `Select Image`,
        validation: lang.parseField === "field_content_english" ? { required: `Image is required` } : undefined,
      });
    }
    fields.push(
      {
        fieldName: `Title (${lang.code})`,
        fieldValue: `${basePath}.title`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.title`,
        formType: "input",
        label: `Title (${lang.code})`,
        placeholder: `Enter Title ${lang.code}`,
        validation:
          lang.parseField === "field_content_english" ? { required: `Title ${lang.code} is required` } : undefined,
      },
      {
        fieldName: `Intro Text (${lang.code})`,
        fieldValue: `${basePath}.introText`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.introText`,
        formType: "richText",
        label: `Intro Text (${lang.code})`,
        placeholder: `Enter Intro Text ${lang.code}`,
        validation:
          lang.parseField === "field_content_english" ? { required: `Intro Text ${lang.code} is required` } : undefined,
      },
      {
        fieldName: `Extro Text (${lang.code})`,
        fieldValue: `${basePath}.extroText`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.extroText`,
        formType: "richText",
        label: `Extro Text (${lang.code})`,
        placeholder: `Enter Extro Text ${lang.code}`,
        validation:
          lang.parseField === "field_content_english" ? { required: `Extro Text ${lang.code} is required` } : undefined,
      }
    );
    return fields;
  });
};

export const generateFieldsSideData = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[],
  idx: any
): ModuleFields[] => {
  return languages.flatMap((lang) => {
    const fields: ModuleFields[] = [];
    if (lang.parseField === "field_content_english") {
      fields.push({
        fieldName: `Image`,
        fieldValue: `${basePath}.siderData[${idx}].image`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "image",
        name: `${lang.parseField}.${basePath}.siderData[${idx}].image`,
        formType: "file",
        usedFileType: "image/*",
        label: `Image`,
        placeholder: `Select Image`,
        validation: lang.parseField === "field_content_english" ? { required: `Image is required` } : undefined,
      });
    }
    fields.push(
      {
        fieldName: `Title (${lang.code})`,
        fieldValue: `${basePath}.siderData[${idx}].title`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.siderData[${idx}].title`,
        formType: "input",
        label: `Title (${lang.code})`,
        placeholder: `Enter Title ${lang.code}`,
        validation:
          lang.parseField === "field_content_english" ? { required: `Title ${lang.code} is required` } : undefined,
      },
      {
        fieldName: `Description (${lang.code})`,
        fieldValue: `${basePath}.siderData[${idx}].description`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.siderData[${idx}].description`,
        formType: "richText",
        label: `Description (${lang.code})`,
        placeholder: `Enter Description ${lang.code}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Description ${lang.code} is required` }
            : undefined,
      }
    );
    return fields;
  });
};

export const languages = [
  { code: "EN", label: "English", parseField: "field_content_english" },
  { code: "MS", label: "Malay", parseField: "field_content_malay" },
  { code: "ZH", label: "Mandarin", parseField: "field_content_mandarin" },
];

let url = `/api/page-content/all-fields?pageName=sustainability/creating-inspiring-workplace`;

export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;

const fetchProfileData = async (): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    const res = await corporateCMSApi.get(url);
    const profileData = res.data;

    if (!profileData?.[0]?.field_content_english?.data) {
      return null;
    }

    // Generate fields for main data
    const dataFields = generateFields("data", languages);

    const dataFieldsSideData =
      profileData?.[0]?.field_content_english?.data?.siderData?.map((item: any, index: number) =>
        generateFieldsSideData("data", languages, index)
      ) || [];

    const dataFieldsFeatures =
      profileData?.[0]?.field_content_english?.data?.features?.map((item: any, index: number) =>
        generateFieldsFeatures("data", languages, index)
      ) || [];

    console.log("dataFields -environmental", dataFields, dataFieldsSideData);

    return {
      creatingInspiringWorkplaceMainContent: dataFields as ModuleFields[],
      creatingInspiringWorkplaceSiderData: dataFieldsSideData as ModuleFields[],
      creatingInspiringWorkplaceFeatures: dataFieldsFeatures as ModuleFields[],
    };
  } catch (error) {
    console.error("Error fetching profile data:", error);
    return null;
  }
};

export const getCreatingInspiringWorkplaceDrillDownData = async () => {
  if (!getData) {
    getData = await fetchProfileData();
  }
  return getData;
};
